import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { version } from 'src/environments/version';

@Component({
    selector: 'version-modal',
    templateUrl: 'version-modal.component.html',
})
export class VersionModalComponent {
    version: string = `v${version?.version || '0.0.0'}`;

    isDev = !environment.production;

    active_tab = 0;

    constructor(private modalService: NgbModal) {}

    openScrollableContent(longContent) {
        this.modalService.open(longContent, {
            scrollable: true,
            backdrop: 'static',
        });
    }
}
